import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Loader from "~components/Form/components/Loader";
import { Check, IconErrorNew, IconSucess2, IconSucessNew, WarningIcon } from "~misc/icons";
import { reportListingTypes } from "./reportListingTypes";

const statusCell = ({ statusEntrega }) => {
  const status =
    typeof statusEntrega === "string"
      ? {
          label: statusEntrega,
          type: statusEntrega.toLowerCase().includes("atras") ? "late" : "ok",
        }
      : statusEntrega;

  const isOnTime = status?.type === "ok";

  return (
    <div className="flex items-center gap-2 text-[13px] font-bold leading-tight">
      {isOnTime ? (
        <IconSucessNew className="h-[20px] w-[20px] text-[#8DC63F]" />
      ) : (
        <IconErrorNew className="h-[20px] w-[20px]" />
      )}

      <span className={isOnTime ? "text-[#2A5B11]" : "text-[#D93000]"}>{status?.label || "-"}</span>
    </div>
  );
};

const listingsByType = {
  [reportListingTypes.posicaoCarga]: {
    columns: [
      { key: "statusEntrega", label: "Status da Entrega", render: statusCell },
      { key: "pedido", label: "Pedido" },
      { key: "dataCriacao", label: "Data Criação" },
      { key: "cliente", label: "Cliente" },
      { key: "previsaoEntrega", label: "Previsão de Entrega" },
      { key: "previsaoEntregaAjustada", label: "Previsão de Entrega Ajustada" },
      { key: "statusPedido", label: "Status do Pedido" },
    ],
    rows: [
      { id: 1, statusEntrega: { type: "ok", label: "Dentro do prazo" }, pedido: "2050598918", dataCriacao: "03/02/2026", cliente: "1373100 - A. L. GOMES LTDA", previsaoEntrega: "03/02/2026", previsaoEntregaAjustada: "03/02/2026", statusPedido: "Aguardando carregamento" },
      { id: 2, statusEntrega: { type: "late", label: "Atraso acima do esperado" }, pedido: "2050598918", dataCriacao: "03/02/2026", cliente: "1152612 - A. ALVES MELLO & V ALVES MELLO LTDA", previsaoEntrega: "03/02/2026", previsaoEntregaAjustada: "03/02/2026", statusPedido: "Em separação" },
      { id: 3, statusEntrega: { type: "late", label: "Atraso acima do esperado" }, pedido: "2050598918", dataCriacao: "03/02/2026", cliente: "1152612 - A. ALVES MELLO & V ALVES MELLO LTDA", previsaoEntrega: "03/02/2026", previsaoEntregaAjustada: "03/02/2026", statusPedido: "Em separação" },
      { id: 4, statusEntrega: { type: "late", label: "Atraso acima do esperado" }, pedido: "2050598918", dataCriacao: "03/02/2026", cliente: "1152612 - A. ALVES MELLO & V ALVES MELLO LTDA", previsaoEntrega: "03/02/2026", previsaoEntregaAjustada: "03/02/2026", statusPedido: "Em separação" },
      { id: 5, statusEntrega: { type: "late", label: "Atraso acima do esperado" }, pedido: "2050598918", dataCriacao: "03/02/2026", cliente: "1152612 - A. ALVES MELLO & V ALVES MELLO LTDA", previsaoEntrega: "03/02/2026", previsaoEntregaAjustada: "03/02/2026", statusPedido: "Em separação" },
      { id: 6, statusEntrega: { type: "late", label: "Atraso acima do esperado" }, pedido: "2050598918", dataCriacao: "03/02/2026", cliente: "1152612 - A. ALVES MELLO & V ALVES MELLO LTDA", previsaoEntrega: "03/02/2026", previsaoEntregaAjustada: "03/02/2026", statusPedido: "Em separação" },
      { id: 7, statusEntrega: { type: "late", label: "Atraso acima do esperado" }, pedido: "2050598918", dataCriacao: "03/02/2026", cliente: "1152612 - A. ALVES MELLO & V ALVES MELLO LTDA", previsaoEntrega: "03/02/2026", previsaoEntregaAjustada: "03/02/2026", statusPedido: "Em separação" },
      { id: 8, statusEntrega: { type: "late", label: "Atraso acima do esperado" }, pedido: "2050598918", dataCriacao: "03/02/2026", cliente: "1152612 - A. ALVES MELLO & V ALVES MELLO LTDA", previsaoEntrega: "03/02/2026", previsaoEntregaAjustada: "03/02/2026", statusPedido: "Em separação" },
      { id: 9, statusEntrega: { type: "ok", label: "Dentro do prazo" }, pedido: "2050598922", dataCriacao: "04/02/2026", cliente: "1373100 - A. L. GOMES LTDA", previsaoEntrega: "04/02/2026", previsaoEntregaAjustada: "04/02/2026", statusPedido: "Faturado" },
      { id: 10, statusEntrega: { type: "late", label: "Atraso acima do esperado" }, pedido: "2050598930", dataCriacao: "04/02/2026", cliente: "1875946 - CONSTRUCASA MATERIAIS", previsaoEntrega: "05/02/2026", previsaoEntregaAjustada: "06/02/2026", statusPedido: "Em separação" },
      { id: 11, statusEntrega: { type: "ok", label: "Dentro do prazo" }, pedido: "2050598942", dataCriacao: "05/02/2026", cliente: "1373100 - A. L. GOMES LTDA", previsaoEntrega: "06/02/2026", previsaoEntregaAjustada: "06/02/2026", statusPedido: "Aguardando carregamento" },
      { id: 12, statusEntrega: { type: "late", label: "Atraso acima do esperado" }, pedido: "2050598951", dataCriacao: "05/02/2026", cliente: "1152612 - A. ALVES MELLO & V ALVES MELLO LTDA", previsaoEntrega: "06/02/2026", previsaoEntregaAjustada: "07/02/2026", statusPedido: "Em separação" },
    ],
  },
  [reportListingTypes.autosservicos]: {
    columns: [
      { key: "cliente", label: "Cliente" },
      { key: "media3m", label: "Média pedidos últimos 3M" },
      { key: "pedidosMesAtual", label: "Pedidos mês atual" },
      { key: "webCliente", label: "% de pedidos WEB_CLIENTE" },
      { key: "webVendedor", label: "% de pedidos WEB_VENDEDOR" },
      { key: "outrosCanais", label: "% de pedidos outros canais" },
    ],
    rows: [
      { id: 1, cliente: "1373100 - A. L. GOMES LTDA", media3m: "102", pedidosMesAtual: "87", webCliente: "30%", webVendedor: "40%", outrosCanais: "30%" },
      { id: 2, cliente: "1152612 - A. ALVES MELLO & V ALVES MELLO LTDA", media3m: "10", pedidosMesAtual: "5", webCliente: "15%", webVendedor: "70%", outrosCanais: "20%" },
      { id: 3, cliente: "1373100 - A. L. GOMES LTDA", media3m: "63", pedidosMesAtual: "52", webCliente: "30%", webVendedor: "40%", outrosCanais: "30%" },
      { id: 4, cliente: "1152612 - A. ALVES MELLO & V ALVES MELLO LTDA", media3m: "102", pedidosMesAtual: "87", webCliente: "20%", webVendedor: "50%", outrosCanais: "15%" },
      { id: 5, cliente: "1373100 - A. L. GOMES LTDA", media3m: "10", pedidosMesAtual: "10", webCliente: "20%", webVendedor: "70%", outrosCanais: "30%" },
      { id: 6, cliente: "1152612 - A. ALVES MELLO & V ALVES MELLO LTDA", media3m: "63", pedidosMesAtual: "52", webCliente: "10%", webVendedor: "50%", outrosCanais: "25%" },
      { id: 7, cliente: "1875946 - CONSTRUCASA MATERIAIS", media3m: "49", pedidosMesAtual: "36", webCliente: "25%", webVendedor: "55%", outrosCanais: "20%" },
      { id: 8, cliente: "1875987 - CONSTRUCASA MATERIAIS - LOJA 2", media3m: "28", pedidosMesAtual: "22", webCliente: "18%", webVendedor: "62%", outrosCanais: "20%" },
      { id: 9, cliente: "1373100 - A. L. GOMES LTDA", media3m: "78", pedidosMesAtual: "59", webCliente: "29%", webVendedor: "41%", outrosCanais: "30%" },
      { id: 10, cliente: "1152612 - A. ALVES MELLO & V ALVES MELLO LTDA", media3m: "15", pedidosMesAtual: "9", webCliente: "12%", webVendedor: "68%", outrosCanais: "20%" },
      { id: 11, cliente: "1875946 - CONSTRUCASA MATERIAIS", media3m: "54", pedidosMesAtual: "40", webCliente: "24%", webVendedor: "56%", outrosCanais: "20%" },
      { id: 12, cliente: "1875987 - CONSTRUCASA MATERIAIS - LOJA 2", media3m: "31", pedidosMesAtual: "24", webCliente: "19%", webVendedor: "61%", outrosCanais: "20%" },
    ],
  },
  [reportListingTypes.creditoClientes]: {
    columns: [
      { key: "grupoCentralizador", label: "Grupo centralizador" },
      { key: "cliente", label: "Cliente" },
      { key: "descontoGerencial", label: "Desconto gerencial" },
      { key: "outrosCreditos", label: "Outros créditos" },
      { key: "creditoTotal", label: "Crédito total" },
    ],
    rows: [
      { id: 1, grupoCentralizador: "CONSTRUCASA", cliente: "1875946 - CONSTRUCASA MATERIAIS", descontoGerencial: "R$ 1.256,32", outrosCreditos: "R$ 0,00", creditoTotal: "R$ 1.256,23" },
      { id: 2, grupoCentralizador: "SEM GRUPO", cliente: "1373100 - A. L. GOMES LTDA", descontoGerencial: "R$ 1.256,32", outrosCreditos: "R$ 0,00", creditoTotal: "R$ 1.256,23" },
      { id: 3, grupoCentralizador: "CONSTRUCASA", cliente: "1875987 - CONSTRUCASA MATERIAIS - LOJA 2", descontoGerencial: "R$ 1.256,32", outrosCreditos: "R$ 0,00", creditoTotal: "R$ 1.256,23" },
      { id: 4, grupoCentralizador: "CONSTRUCASA", cliente: "1373100 - A. L. GOMES LTDA", descontoGerencial: "R$ 1.256,32", outrosCreditos: "R$ 0,00", creditoTotal: "R$ 1.256,23" },
      { id: 5, grupoCentralizador: "SEM GRUPO", cliente: "1875946 - CONSTRUCASA MATERIAIS", descontoGerencial: "R$ 1.256,32", outrosCreditos: "R$ 0,00", creditoTotal: "R$ 1.256,23" },
      { id: 6, grupoCentralizador: "CONSTRUCASA", cliente: "1373100 - A. L. GOMES LTDA", descontoGerencial: "R$ 1.256,32", outrosCreditos: "R$ 0,00", creditoTotal: "R$ 1.256,23" },
      { id: 7, grupoCentralizador: "SEM GRUPO", cliente: "1875987 - CONSTRUCASA MATERIAIS - LOJA 2", descontoGerencial: "R$ 1.256,32", outrosCreditos: "R$ 0,00", creditoTotal: "R$ 1.256,23" },
      { id: 8, grupoCentralizador: "CONSTRUCASA", cliente: "1373100 - A. L. GOMES LTDA", descontoGerencial: "R$ 1.256,32", outrosCreditos: "R$ 0,00", creditoTotal: "R$ 1.256,23" },
      { id: 9, grupoCentralizador: "CONSTRUCASA", cliente: "1875946 - CONSTRUCASA MATERIAIS", descontoGerencial: "R$ 2.146,90", outrosCreditos: "R$ 120,00", creditoTotal: "R$ 2.266,90" },
      { id: 10, grupoCentralizador: "SEM GRUPO", cliente: "1152612 - A. ALVES MELLO & V ALVES MELLO LTDA", descontoGerencial: "R$ 986,14", outrosCreditos: "R$ 210,22", creditoTotal: "R$ 1.196,36" },
      { id: 11, grupoCentralizador: "CONSTRUCASA", cliente: "1373100 - A. L. GOMES LTDA", descontoGerencial: "R$ 1.502,78", outrosCreditos: "R$ 95,30", creditoTotal: "R$ 1.598,08" },
      { id: 12, grupoCentralizador: "SEM GRUPO", cliente: "1875987 - CONSTRUCASA MATERIAIS - LOJA 2", descontoGerencial: "R$ 1.078,65", outrosCreditos: "R$ 0,00", creditoTotal: "R$ 1.078,65" },
    ],
  },
};

const ReportListings = ({
  type = reportListingTypes.posicaoCarga,
  dataByType,
  pageSize = 6,
  updatedAt = "11/09/2025",
  footerNote = "Atualização de segunda a sábado de hora em hora das 08:00 às 19:00",
}) => {
  const sourceListings = useMemo(() => dataByType || listingsByType, [dataByType]);
  const listing = useMemo(
    () =>
      sourceListings[type] ||
      sourceListings[reportListingTypes.posicaoCarga] ||
      listingsByType[reportListingTypes.posicaoCarga],
    [sourceListings, type],
  );
  const fallbackListing = useMemo(
    () => listingsByType[type] || listingsByType[reportListingTypes.posicaoCarga],
    [type],
  );
  const columns = useMemo(
    () => listing.columns || fallbackListing.columns,
    [fallbackListing.columns, listing.columns],
  );
  const rows = useMemo(() => listing.rows || [], [listing.rows]);

  const [visibleCount, setVisibleCount] = useState(pageSize);

  useEffect(() => {
    setVisibleCount(pageSize);
  }, [pageSize, type, rows]);

  const visibleRows = useMemo(() => {
    return rows.slice(0, visibleCount);
  }, [rows, visibleCount]);

  const hasMore = visibleCount < rows.length;

  const sentinelaRef = useRef(null);

  const loadMoreRows = useCallback(() => {
    setVisibleCount((currentCount) => Math.min(currentCount + pageSize, rows.length));
  }, [pageSize, rows.length]);


  useEffect(() => {
    const alvo = sentinelaRef.current;
    if (!alvo || !hasMore) return undefined;

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) loadMoreRows();
    });
    observer.observe(alvo);
    return () => observer.disconnect();
  }, [hasMore, loadMoreRows, visibleCount]);

  return (
    <section className="container ">
      <p className="mb-2 text-sm ">
        Exibindo <span className="font-bold text-[#091D4A]">{visibleRows.length}</span> de{" "}
        <span className="font-bold text-[#091D4A]">{rows.length}</span>
      </p>

      <div className="overflow-x-auto rounded-md bg-white">
        <table className="min-w-full border-collapse">
          <thead>
            <tr className="bg-[#01054C] text-left text-white">
              {columns.map((column) => (
                <th key={column.key} className="px-3 py-3 text-[12px] font-semibold leading-tight first:pl-6 last:pr-4">
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {visibleRows.map((row, rowIndex) => {
              const rowKey = `${type}-${rowIndex}-${row.id ?? "row"}`;
              return (
                <tr key={rowKey} className="border-b border-[#E4E8EF] text-[#091D4A]">
                  {columns.map((column) => (
                    <td key={`${rowKey}-${column.key}`} className="px-3 py-3 text-[12px] font-bold align-top first:pl-6 last:pr-4">
                      {column.render ? column.render(row) : row[column.key]}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {hasMore && (
        <div ref={sentinelaRef} className="flex items-center justify-center py-3">
          <Loader />
        </div>
      )}

      <footer className="py-5 text-center text-[#8D96A8]">
        <p className="text-sm">
          Dados atualizados em <span className="font-bold text-[#091D4A]">{updatedAt}</span>
        </p>
        {footerNote && <p className="text-sm">{footerNote}</p>}
      </footer>
    </section>
  );
};

const MemoReportListings = React.memo(ReportListings);
export default MemoReportListings;
